import React, { useContext, useState } from 'react'
import { Table, Tag } from 'antd'
import styled from 'styled-components'
import moment from 'moment-timezone'
import { useHistory } from 'react-router-dom'
import { useSubscription } from '@apollo/client'
import { SUB_LOCATION_GROUPS } from 'Util/subscriptions'
import { LocationGroupsContext } from '..'
import TableFilters from './TableFilters'

const Container = styled.div``

const columns = [
    {
        title: 'Label',
        dataIndex: 'label',
        key: 'label',
        sorter: (a, b) => a.label?.localeCompare(b.label),
    },
    {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        render: v => v || <span style={{ color: '#bbb' }}>—</span>,
    },
    {
        title: 'Locations',
        dataIndex: 'location_ids',
        key: 'location_ids',
        width: 120,
        render: ids => <Tag>{ids?.length ?? 0}</Tag>,
        sorter: (a, b) => (a.location_ids?.length ?? 0) - (b.location_ids?.length ?? 0),
    },
    {
        title: 'Updated',
        dataIndex: 'updated_at',
        key: 'updated_at',
        width: 180,
        render: v => moment(v).tz('Asia/Kolkata').format('DD MMM YYYY HH:mm'),
        sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at),
    },
]

function DataTable() {
    const history = useHistory()
    const { selectedRecord, setSelectedRecord } = useContext(LocationGroupsContext)
    const [data, setData] = useState([])

    const { loading } = useSubscription(SUB_LOCATION_GROUPS, {
        variables: { where: { deleted_at: { _is_null: true } } },
        onSubscriptionData({ subscriptionData }) {
            const groups = subscriptionData?.data?.location_groups ?? []
            setData(groups.map(g => ({ ...g, key: `loc-group-${g.id}` })))
        },
    })

    const rowSelection = {
        type: 'radio',
        selectedRowKeys: selectedRecord?.id ? [`loc-group-${selectedRecord.id}`] : [],
        onSelect: (record) => setSelectedRecord(record),
    }

    return (
        <Container>
            <TableFilters data={data} columns={columns} />
            <Table
                size='small'
                rowKey='key'
                loading={loading}
                columns={columns}
                dataSource={data}
                rowSelection={rowSelection}
                pagination={{ pageSize: 20, showSizeChanger: false }}
                locale={{ emptyText: 'No location groups yet. Click "New" to create one.' }}
                onRow={(record) => ({
                    onClick: () => setSelectedRecord(record),
                    onDoubleClick: () => history.push(`/procurement/auction/groups/edit/${record.id}`),
                    style: { cursor: 'pointer' },
                })}
            />
        </Container>
    )
}

export default DataTable
